import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Icon } from '../Icon';
import CustomLink from '../CustomLink';
import styles from './Button.css';
import { Loader } from '../Loader';

const cx = classnames.bind(styles);

function Button(props) {
    const {label, className, onClick, iconLeft, iconRight, type, disabled, link, isLoading, rounded} = props;
    const classes = cx({
        root: true,
        [type]: Boolean(type),
        [className]: Boolean(className),
        withoutLabel: !label,
        rounded,
        disabled,
        loading: isLoading
    });

    const renderContent = () => (
        <>
            {Boolean(iconLeft?.name) && (
                <Icon
                    name={iconLeft.name}
                    className={styles.icon}
                />
            )}
            {label}
            {Boolean(iconRight?.name) && (
                <Icon
                    name={iconRight.name}
                    className={styles.icon}
                />
            )}
            {isLoading && <Loader className={styles.loader} />}
        </>
    )

    if (Boolean(link)) {
        return (
            <CustomLink
                className={classes}
                onClick={onClick}
                withDefaultClassName={false}
                {...link}
            >
                {renderContent()}
            </CustomLink>
        )
    }

    return (
        <button
            className={classes}
            onClick={onClick}
        >
            {renderContent()}
        </button>
    );
}

Button.propTypes = {
    iconLeft: PropTypes.object,
    iconRight: PropTypes.object,
    label: PropTypes.string,
    onClick: PropTypes.func,
    className: PropTypes.string,
    type: PropTypes.string,
    disabled: PropTypes.bool,
    link: PropTypes.object,
    isLoading: PropTypes.bool,
    rounded: PropTypes.bool
};

Button.defaultProps = {
    onClick: null,
    className: '',
    iconLeft: null,
    iconRight: null,
    type: 'primary',
    label: '',
    link: null,
    disabled: false,
    isLoading: false,
    rounded: false
};

export {
    Button
};
